$(document).ready(function () {

    if ($(".in-index").length) {
        const shopDataLayer = getShopDataLayer();
        const topBanner = shopDataLayer.homepage.topBanner || { button: {} };
        const $banners = $(".next-to-carousel-banners");

        $banners.wrap("<div class='top-categories'></div>");

        if (topBanner.title) {
            $("<div class='top-categories__title'>" +
                "<h2>" + topBanner.title + "</h2>" +
                "<a href='" + topBanner.button.link + "'>" + topBanner.button.text + "</a>" +
                "</div>").prependTo($banners.parent());
        }

        $(".container--bannersBenefit").insertBefore("#footer");

        $(".homepage-texts-wrapper").insertBefore($("#tab-content > div").first());

        // Obalit titulek produktového slideru do <span> a appendovat proklik
        if (Array.isArray(shopDataLayer.homepage.productSliderLinks)) {
            shopDataLayer.homepage.productSliderLinks.forEach(function (item) {
                const $heading = $(".homepage-products-heading-" + item.id);
                if ($heading.length === 0) return;

                $heading.contents().filter(function () {
                    return this.nodeType === 3;
                }).wrap("<span class='hp-group-title-text'></span>");

                $("<a href='" + item.link + "' class='hp-group-link'>" + item.text + "</a>")
                    .appendTo($heading);
            });
        }
    }
});
